// The Maps tab (MapsEditor) and its coordinates editor (MapOverlay)
const en = {
  title: 'Maps',
  subtitle: 'The plans of the festival areas, and where each one sits on the map.',
  addMap: 'Add map',
  untitled: 'Untitled Map',
  boundsHint: 'Top left → bottom right (latitude, longitude)',
  empty: 'No maps yet. Add the festival plan to pin places on it.',
  /** The name a new map starts with */
  newMap: 'New Map',
  addTitle: 'Add Map',
  editTitle: 'Edit Map',
  name: 'Name',
  namePlaceholder: 'Map name',
  image: 'Map Image',
  currentCoordinates: 'Current coordinates:',
  topLeft: 'Top-Left:',
  bottomRight: 'Bottom-Right:',
  editCoordinates: 'Edit coordinates',
  coordinatesTitle: 'Set Map Coordinates',
  deleteTitle: 'Delete map',
  deleteConfirm: 'Are you sure you want to delete this map?',
  cantSave: 'Can\'t save the map',
  imageMissing: 'Please set a map image',
  coordinatesMissing: 'Please set map coordinates',
  // The coordinates editor's controls: the modal's size decides the saved bounds, so they must stay on one line
  zoomLevel: 'Zoom Level',
  transparency: 'Map Transparency',
  loadingPlan: 'Loading map...',
  initializingMap: 'Initializing map...',
  overlayAlt: 'Map overlay',
};

const fr: typeof en = {
  title: 'Plans',
  subtitle: 'Les plans des espaces du festival, et leur emplacement sur la carte.',
  addMap: 'Ajouter un plan',
  untitled: 'Plan sans titre',
  boundsHint: 'En haut à gauche → en bas à droite (latitude, longitude)',
  empty: 'Aucun plan pour l\'instant. Ajoutez le plan du festival pour y placer des lieux.',
  newMap: 'Nouveau plan',
  addTitle: 'Ajouter un plan',
  editTitle: 'Modifier le plan',
  name: 'Nom',
  namePlaceholder: 'Nom du plan',
  image: 'Image du plan',
  currentCoordinates: 'Coordonnées actuelles\u00a0:',
  topLeft: 'En haut à gauche\u00a0:',
  bottomRight: 'En bas à droite\u00a0:',
  editCoordinates: 'Modifier les coordonnées',
  coordinatesTitle: 'Définir les coordonnées du plan',
  deleteTitle: 'Supprimer le plan',
  deleteConfirm: 'Voulez-vous vraiment supprimer ce plan\u00a0?',
  cantSave: 'Impossible d\'enregistrer le plan',
  imageMissing: 'Veuillez choisir une image pour le plan',
  coordinatesMissing: 'Veuillez définir les coordonnées du plan',
  zoomLevel: 'Niveau de zoom',
  transparency: 'Transparence de la carte',
  loadingPlan: 'Chargement du plan...',
  initializingMap: 'Initialisation de la carte...',
  overlayAlt: 'Plan superposé',
};

const messages = { en, fr };
export default messages;
